import {
  App,
  removeFilter,
  setActiveFilters,
  updateFilter,
  useFilters
} from 'map-filter-view'
import { useDispatch } from 'react-redux'

import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import {
  closeMapFilterDrawer,
  useIsMapFilterDrawerOpen
} from '~map-preview/states/ui'

const MapFilterDrawer = () => {
  const isEmbed = useIsEmbed()
  const dispatch = useDispatch()

  const filters = useFilters()

  const open = useIsMapFilterDrawerOpen()

  const handleFilterRemove = (id) => {
    dispatch(removeFilter(id))
  }

  const handleFilterUpdate = (filter) => {
    dispatch(updateFilter(filter))
  }

  const handleSetActiveFilters = (filters) => {
    dispatch(setActiveFilters(filters))
  }

  const handleClose = () => {
    dispatch(closeMapFilterDrawer())
  }

  return (
    <App
      isEmbed={isEmbed}
      filters={filters}
      open={open}
      onClose={handleClose}
      onFilterRemove={handleFilterRemove}
      onFilterUpdate={handleFilterUpdate}
      onSetActiveFilters={handleSetActiveFilters}
      drawerProps={{ anchor: 'left' }}
    />
  )
}

export { MapFilterDrawer }
